import React from "react";
import { Outlet } from "react-router-dom";
import { BreadCrumb } from "primereact/breadcrumb";

export default function OrdersLayout() {
  const items = [{ label: "Checkout" }];
  const home = { label: "Dashboard", url: "/dashboard/home" };

  return (
    <>
      <div className="menu bg-gray ">
        <div className="container">
          <div className="grid gap-4 p-3">
            <BreadCrumb
              className="bg-transparent border-none"
              model={items}
              home={home}
            />
          </div>
        </div>
      </div>
      <Outlet />
    </>
  );
}
